import React, { Component } from 'react';

class Faq extends Component {
    constructor(props) {
        super(props);
        this.state = {
            faqs: [],
            loading: true,
            error: null,
            activeAccordion: 0 // Track which accordion is open
        }
    }

    componentDidMount() {
        this.fetchFaqData();
    }

    componentDidUpdate(prevProps, prevState) {
        // Re-initialize accordion functionality when data loads
        if (prevState.faqs !== this.state.faqs && this.state.faqs.length > 0) {
            this.initializeAccordions();
        }
    }

    initializeAccordions = () => {
        // You might need to call any existing accordion initialization function here
        // If you're using a library or custom JS for accordions
        console.log('Accordions should be initialized now');
    }

    fetchFaqData = async () => {
        try {
            this.setState({ loading: true, error: null });

            const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:3000';
            const apiUrl = `${baseUrl}/api/faq/active`;

            const response = await fetch(apiUrl);
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const result = await response.json();
            
            if (result.success && Array.isArray(result.data)) {
                this.setState({
                    faqs: result.data,
                    loading: false
                });
            } else {
                throw new Error('Invalid data format from FAQ API');
            }
            
        } catch (error) {
            console.error('Error fetching FAQ data:', error);
            this.setState({
                loading: false,
                error: error.message
            });
        }
    }

    handleAccordionClick = (index) => {
        this.setState(prevState => ({
            activeAccordion: prevState.activeAccordion === index ? -1 : index
        }));
    }

    renderFaqContent() {
        const { faqs, loading, error, activeAccordion } = this.state;

        if (loading) {
            return (
                <div className="themesflat-accordions style-1 has-icon icon-left iconstyle-1 clearfix">
                    <div className="text-center">
                        <div className="loading-spinner">Loading FAQs...</div>
                    </div>
                </div>
            );
        }

        if (error) {
            return (
                <div className="themesflat-accordions style-1 has-icon icon-left iconstyle-1 clearfix">
                    <div className="text-center error-message">
                        <p>Error loading FAQs: {error}</p>
                        <button 
                            onClick={this.fetchFaqData} 
                            className="themesflat-button bg-accent small"
                            style={{ marginTop: '10px' }}
                        >
                            Retry
                        </button>
                    </div>
                </div>
            );
        }

        if (!faqs || faqs.length === 0) {
            return (
                <div className="themesflat-accordions style-1 has-icon icon-left iconstyle-1 clearfix">
                    <div className="text-center">
                        <p>No FAQs available at the moment.</p>
                    </div>
                </div>
            );
        }

        return (
            <div className="themesflat-accordions style-1 has-icon icon-left iconstyle-1 clearfix">
                {faqs.map((faq, index) => (
                    <div 
                        className={`accordion-item ${activeAccordion === index ? 'active' : ''}`} 
                        key={faq._id || faq.id}
                    >
                        <h3 
                            className="accordion-heading"
                            onClick={() => this.handleAccordionClick(index)}
                            style={{ cursor: 'pointer' }}
                        >
                            <span className="inner">{faq.question}</span>
                        </h3>
                        <div 
                            className="accordion-content"
                            style={{ 
                                display: activeAccordion === index ? 'block' : 'none'
                            }}
                        >
                            <div>{faq.answer}</div>
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    render() {
        return (
            <div className="col-md-6">
                <div className="themesflat-spacer clearfix" data-desktop={0} data-mobile={0} data-smobile={35} />
                <div className="themesflat-content-box" data-margin="0 0 0 18px" data-mobilemargin="0 0 0 0">
                    <div className="themesflat-headings style-1 clearfix">
                        <h2 className="heading">FAQs</h2>
                        <div className="sep has-width w80 accent-bg margin-top-11 clearfix" />
                    </div>
                    <div className="themesflat-spacer clearfix" data-desktop={38} data-mobile={35} data-smobile={35} />
                    {this.renderFaqContent()}
                </div>
            </div>
        );
    }
}

export default Faq;